<template>
  <div>
    <el-dropdown class="custom-column-dropdown" :hide-on-click="true" trigger="click">
      <el-button>自定义列</el-button>
      <el-dropdown-menu slot="dropdown">
        <li class="custom-column-dropdown-title">常用自定义列（{{ customColTemplateListLength }}/20）</li>
        <el-dropdown-item :command="dropdownItem.id" v-for="dropdownItem in customColTemplateList" :key="dropdownItem.id">
          <div class="custom-column-dropdown-item" :class="{ 'is-check': activeTemplateId === dropdownItem.id }">
            <span class="check el-icon-check"></span>
            <span class="custom-column-dropdown-item-name" :title="dropdownItem.name" @click="selectCustomTemplate(dropdownItem)">
              {{ dropdownItem.name }}
            </span>
            <span class="btns">
              <span class="el-icon-edit" @click="updateCustomColTemplate(dropdownItem)"></span>
              <span>&ensp;&ensp;</span>

              <el-popconfirm @confirm="removeCustomColTemplate(dropdownItem.id)" title="确定删除吗？">
                <span slot="reference" class="el-icon-circle-close" @click.stop></span>
              </el-popconfirm>
            </span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="showCustomModal">自定义</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <CustomColumn
      ref="tableCustomColsRef"
      :name="name"
      :raw-data="defaultTableCols"
      :navs="navs"
      :visible.sync="showCustomColumnConfigModal"
      @change="onCustomColumnChange"
    ></CustomColumn>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import store from '@/store'
import CustomColumn from './index.vue'

import { useCustomTableColumn } from './useCustomTableColumnModal.js'

// eslint-disable-next-line
const emits = defineEmits(['change'])
// eslint-disable-next-line
const props = defineProps({
  // 本地缓存的key
  name: {
    type: String,
    required: true
  },
  // 默认配置的json表格列数据
  colList: {
    type: Object,
    required: true
  },

  menuId: {
    type: String,
    required: true
  },
  extendId: {
    type: Number,
    default: 0
  },

  // 左侧导航数据
  navs: {
    type: Array,
    default: () => []
  }
})
const accessAuth = computed(() => store.state.accessAuth)
const defaultTableCols = computed(() => {
  const defaultCols = {}
  for (const i in props.colList) {
    const cols = props.colList[i]
    defaultCols[i] = cols.filter((col) => !col.auth || accessAuth.value.includes(col.auth))
  }
  return defaultCols
})

const {
  activeTemplateId,
  showCustomColumnConfigModal,
  tableCustomColsRef,
  customColTemplateList,
  customColTemplateListLength,
  getCustomColTemplates,
  selectCustomTemplate,
  removeCustomColTemplate,
  updateCustomColTemplate,
  showCustomModal,
  getActiveTemplate,
  onCustomColumnChange
} = useCustomTableColumn(emits, props)

getCustomColTemplates().then(getActiveTemplate)

// eslint-disable-next-line
defineExpose({
  updateTableColWidth: (newWidth, column) => {
    tableCustomColsRef.value.updateTableColWidth(newWidth, column)
  }
})
</script>

<style lang="scss" scoped></style>
